import axios from "axios";

const apiUrl = "api/employee-calendar";

export default class EmployeeCalendarService {

  public getEmployeeCalendarData(filter?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${apiUrl}/all-paging`, filter)
        .then(res => {
          resolve(res.data);
        }).catch(err => {
          reject(err);
      });
    });
  }

  public getEmployeeDocByDate(date?: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${apiUrl}/all-docs-by-date/${date}`)
        .then(res => {
          resolve(res.data);
        }).catch(err => {
          reject(err);
      });
    });
  }

  public getPerformerTypes(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(apiUrl + '/performer-types')
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
